window.themeAPI = window.themeAPI || {};

themeAPI.cacheSelectors = function () {
  themeAPI.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $variantImage: $('#VariantImage'),
    $productImageGallery: $('.gallery__item'),

    // Add to cart - Ajax
    $cartBuggle: $('.cart-link__bubble'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

themeAPI.init = function () {
  themeAPI.cacheSelectors();
  timber.cacheVariables();
  themeAPI.productImageGallery();
  themeAPI.enableAjax();
};

themeAPI.productImageGallery = function() {
  if (!themeAPI.cache.$productImageGallery.length) {
    return;
  };

  themeAPI.cache.$productImage.on('click', function() {
    var imageId = $(this).attr('data-image-id');
    // console.log(imageId)
    themeAPI.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });

  themeAPI.cache.$variantImage.on('click', function() {
    var imageId = $(this).attr('data-image-id');
    themeAPI.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });

  themeAPI.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Translation missing: en.products.zoom.close',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Translation missing: en.products.zoom.prev',
      tNext: 'Translation missing: en.products.zoom.next'
    }
  });
};

themeAPI.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

themeAPI.renderCartDrawerItem = function (item) {
  // console.log(item)
  if (item.id) {
    $('.cart-drawer__empty-text').addClass('hidden');
    $('.cart-drawer__footer').removeClass('hidden');
  }

  let  customData = {}, 
  drawer__itemImage = '', 
  drawer__itemOptions = '',
  drawer__itemDiscount = '',
  drawer__itemPrice = '';

  if (item.properties && item.properties._customorderid) {
    customData.orderid = item.properties._customorderid;
    customData.trozosurl = item.url.split('?')[0];
    customData.orderkey = item.properties._customorderkey;
    customData.imagefront = item.properties._customimagefront;
    customData.imageback = item.properties._customimageback;
    customData.auth = item.properties._customauth;

    drawer__itemImage = `<a href="${customData.trozosurl}?id=${customData.orderid}&key=${customData.orderkey}&imf=${customData.imagefront}&imb=${customData.imageback}&auth=${customData.auth}"
      class="cart__image block">
      <img src="//s3.amazonaws.com/qsmzorderimages/${customData.imagefront}"
        style="width: 150px" alt="${item.title}">
    </a>`;
  }else{
    let webp_flag = item.image.includes('.webp') ? true : false;
    let imageArr,itemImage; 
    if(webp_flag){
      imageArr = item.image.split('.webp');
      itemImage = imageArr[0] + '_medium.webp' + imageArr[1];
    }else{
      imageArr = item.image.split('.png');
      itemImage = imageArr[0] + '_medium.png' + imageArr[1];
    }
    drawer__itemImage = `<a href="${item.url}" class="cart__image block">
      <img src="${itemImage}" alt="${item.title}">
    </a>`;
  }

  if (!item.product_has_only_default_variant) {
    for (let i = 0; i < item.variant_options.length; i++) {
      const optionValue = item.variant_options[i];
      drawer__itemOptions += `<span class="block">${optionValue}</span>`;
    }
  }

  if (item.original_line_price != item.final_line_price) {
    const original_price = Shopify.formatMoney(item.original_line_price, "");
    drawer__itemPrice = `<small class="cart-item__original-price">
    <s>${original_price}</s>
    </small>`;
  }
  const current_price = Shopify.formatMoney(item.final_line_price, "");
  drawer__itemPrice += `<span class="money">${current_price}</span>`;

  if (item.original_line_price != item.final_line_price && item.discounts.length > 0 ) {
    for (let i = 0; i < item.discounts.length; i++) {
      const discount = item.discounts[i];
      drawer__itemDiscount += `<small class="cart-item__discount text-size-12">
        ${discount.title}
      </small>`;
    }
  }

  let minusInput = '<input type="button" class="on-quantity" value="-" data-v="-1">', 
    plusInput= '<input type="button" class="on-quantity" value="+" data-v="1">', 
    quantifyMax = 999,
    quantityOverHintDisplay = 'hidden',
    currentVariant = {};

  $.getJSON(`/products/${item.handle}.js`, function(product) {
    // console.log(product);
    let product_variants = product.variants;
    for (let i = 0; i < product_variants.length; i++) {
      const variant_id = product_variants[i].id;
      if (item.id == variant_id) {
        currentVariant = product_variants[i];
        if (item.quantity == 1) {
          minusInput = `<input type="button" class="on-quantity" value="-" data-v="-1" disabled>`;
        }

        if (item.quantity == currentVariant.inventory_quantity) {
          plusInput = `<input type="button" class="on-quantity" value="+" data-v="1" disabled>`;
        }

        if (currentVariant.inventory_policy == 'deny') {
          quantifyMax = currentVariant.inventory_quantity;
        }

        if (item.quantity >= currentVariant.inventory_quantity && currentVariant.inventory_policy == 'deny' ) {
          quantityOverHintDisplay = '';
        }
        break;
      }
    }
  });

  let sticker_notice = '', notice_text = '';
  const item_handle = item.handle;
  if (item_handle.includes('random-gift-for-order-paid-over')) {
    notice_text = `Note: We gift only <b>one</b> item if your order is paid over a certain amount as listed, otherwise, it won't be delivered.`;
  } else {
    switch (item_handle) {
      case 'magsafe-sticker':
        notice_text = 'Note: The MagSafe Sticker is free when you purchase Air Case for iPhone 13 series. Otherwise, it won’t be delivered.'
        break;
      case 'lucky-box-for-usa':
        notice_text = `Important information:<br>
          1. Please note that we will prioritize shipping your preferred color, 
          but if it is out of stock, we will send a random color case to you.<br>
          2. If the cases you receive do not have any defects, we do not support refunds.`;
        break;
      case 'magez-grip-gift':
        notice_text = 'Important Notice: Item shipment requires a minimum order of $70. Orders below this amount will not be delivered. This offer expires on Dec 28th at 11:59 PM PST'
        break;
      case 'charging-cable-extended-version-2m':
        notice_text = 'Free Extended c-c cable for the first 300 orders only. iPhone 15 series pre-order now. Shipping will begin on September 13th.';
        break;
    }
  }
  if (notice_text != '') {
    sticker_notice = `<div class="w-full bg-black bg-opacity-5 border border-black border-opacity-10 p-2 mb-2 text-size-12">
      ${notice_text}
    </div>`;
  }

  const cartDrawerItemHTML = `<div
    class="cart-drawer__item relative border-b border-black border-opacity-10 pt-6 pb-8"
    data-cart-item data-cart-item-id="${item.key}" aria-live="polite">
    ${sticker_notice}
    <div class="cart-drawer__item-images">
      ${drawer__itemImage}
    </div>

    <div class="cart-drawer__item-content pl-4">
      <a href="${item.url}" class="cart-drawer__item-title font-bold text-size-12 line-clamp-1"
        data-cart-item-href data-cart-item-title>${item.product_title}</a>
      <p class="cart-drawer__item-subtitle text-size-12 mt-2 mb-3" data-cart-item-variant-title>
        ${drawer__itemOptions}
      </p>

      <ul class="cart-drawer__item-properties" data-cart-item-property-list></ul>

      <div class="cart-drawer__item-price-container" data-cart-item-price-container>
        <span class="text-size-14 font-semibold">
          ${drawer__itemPrice}
        </span>
        ${drawer__itemDiscount}
      </div>

      <div class="cart-drawer__item-bottom flex justify-between items-center mt-2">
        <div class="quantity-box">
          ${minusInput}
          <input id="quantity_${item.key}" class="cart-drawer__item-quantity text-size-12" name="quantity"
            type="text" value="${item.quantity}" data-min="1" data-max="${quantifyMax}" data-cart-item-input-quantity>
          ${plusInput}
        </div>

        <button class="cart-drawer__item-delete btn-link" type="button" data-cart-item-delete>
          <span class="text-size-12 border-b border-black hover:text-red-600 hover:border-red-600">Remove</span>
        </button>
        
        <span class="quantity_over_hint static mt-2 sm:absolute sm:mt-0 sm:bottom-1 right-0 text-size-12 text-red-600 ${quantityOverHintDisplay}">
          All ${currentVariant.inventory_quantity} ${currentVariant.title} are in your cart.
        </span>
      </div>
    </div>
  </div>`;

  let drawer_hasItem = false;
  $('.cart-drawer__item-list').find('.cart-drawer__item').each(function(){
    var $this = $(this);
    const itemId = $this.data('cart-item-id');
    
    if(item.key == itemId){
      drawer_hasItem = true;
      var currentQuantity = item.quantity;
      $this.find('input.cart-drawer__item-quantity').val(currentQuantity);
    }
  })

  if(!drawer_hasItem){
    $('.cart-drawer__item-list').prepend(cartDrawerItemHTML);
  }
}

themeAPI.addToCartflip = function ($addToCartBtn,item) {
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to cart";
  $addToCartBtn
    .attr('data-add-to-cart', addToCartText)
    .prop('disabled', false)
    .removeClass('disabled')
    .removeClass('btn--loading');

  themeAPI.renderCartDrawerItem(item);
  //Eyeglass Case: 7076095656006
  //MagEZ Grip: 7081968500806
  //MagSafe Sticker: 7013993742406
  //Magnetic Phone Grip: 7041296728134
  //Plant a Tree: 7007230558278
  //Extended C-C Cable: 7131760132166
  //Universal MagSafe Plate: 6988680364102
  const freeItemIds = [7013993742406,7007230558278,7131760132166, 6988680364102];
  if (!freeItemIds.includes(item.product_id)) {
    $('.site-header__cart').click();
  }
};

// themeAPI.addToCartflip = function ($addToCartBtn) {
//   // console.log($addToCartBtn)

//   // Get label of add to cart button
//   var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to cart";

//   // Make a copy of the add to cart button should we flip it
//   $addToCartBtn
//     .clone(true)
//     .prop('disabled', false)
//     .removeClass('disabled')
//     .addClass('btn--unflipped')
//     .find('span')
//     .text(addToCartText)
//     .attr('text',addToCartText)
//     .end()
//     .hide()
//     .insertAfter($addToCartBtn);
  
//   const continueShoppingBtn = `<div class="continue-shopping mt-2.5 py-2 px-6 border border-black bg-white">
//     <a class="block w-full text-center text-size-14 uppercase" href="javascript:;" text="Continue Shopping">Continue Shopping</a>
//   </div>`;

//   $addToCartBtn
//     .unbind('click')
//     .removeClass('disabled')
//     .find('span')
//     .text("View Cart")
//     .attr('text',"View Cart")
//     .end()
//     .bind('click', function(e) {
//       e.preventDefault();
//       window.location.href = '/cart';
//     })
//     .prop('disabled', false)
//     .addClass('btn--flipped')
//     .after(continueShoppingBtn);

//   $('.continue-shopping a').bind('click', function(){
//     if ($(".swatch").length > 0) {
//       $(".swatch-element :radio:checked").click();
//     }else{
//       $('.continue-shopping').remove();
//     }
//   });

//   // Unflip button if another variant is selected
//   $('.swatch-element, .single-option-selector, [name="quantity"]').bind('click', function() {
//     $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
//     $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
//   });
// };

themeAPI.enableAjax = function () {
  themeAPI.cache.$body.on('click', 'form[action^="/cart/add"] :submit', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');
        // console.log($addToCartForm.serialize())
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          //console.log(lineItem)
          //Case 4 for i15: 7158297493574,7159469965382
          //Case Pro 4 for i15: 7158415622214
          //Case 3 for S23: 7088899522630
          //Case Pro 3 for i14: 7000172527686
          //Case 3 for i14: 7000151883846
          //Air Case for i13: 6676963459142,6715813265478,7015780515910
          //Air Case for S22: 6892080398406
          //const halloweenIds = [7000151883846,7000172527686,6802204295238,6699360124998,7010412822598,7015780515910,6715813265478,6715748974662,7020962021446,6903326801990,6821764923462,3981118308422,4693882699846,7026664079430,6906836648006,4835291103302,6707106971718,4463372369990,6821645156422,6801496965190,6679107600454,6937306267718,6935535910982,6988622397510]
          //const productIds_ss = [7088899522630,7000172527686,7000151883846,6676963459142,6715813265478,7015780515910];
          //const productIds_i15 = [7158297493574,7159469965382,7158415622214];
          const productIds = [6676963459142,6715813265478,7015780515910,6892080398406];
          if(productIds.includes(lineItem.product_id)){
            var $freeGiftForm = $addToCartForm.prev('#gift_form');
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              data: $freeGiftForm.serialize(),
              success: function(freeItem) { 
                // console.log(freeItem)
                themeAPI.addToCartflip($addToCartBtn, freeItem);
              }
            });
          }
          
          // if(halloweenIds.includes(lineItem.product_id)){
          //   // console.log(lineItem)
          //   var $freeGripForm = $addToCartForm.prev('#grip_form');
          //   $.ajax({
          //     url: '/cart/add.js',
          //     dataType: 'json',
          //     type: 'post',
          //     data: $freeGripForm.serialize(),
          //     success: function(gripItem) { 
          //       //console.log(gripItem)
          //       themeAPI.addToCartflip($addToCartBtn, gripItem);
          //     }
          //   });
          // }

          // var $freeTreeForm = $addToCartForm.prev('#tree_form');
          // $.ajax({
          //   url: '/cart/add.js',
          //   dataType: 'json',
          //   type: 'post',
          //   data: $freeTreeForm.serialize(),
          //   success: function(freeItem) { 
          //     themeAPI.addToCartflip($addToCartBtn, freeItem);
          //   }
          // });
          
          const data_autoClose = $addToCartForm.serializeArray().filter(item => item.name == 'cart_autoClose');
          if(data_autoClose.length > 0 && $('body>.grid-form-modal').length > 0 ){
            $('body>.grid-form-modal').hasClass('active') && $('body>.grid-form-modal').find('.form_btn-close').click();
          }

          $.getJSON('/cart.js', function(cart) {
            themeAPI.cache.$cartBuggle.addClass("cart-link__bubble--visible");
            themeAPI.cache.$cartBuggle.text(cart.item_count);
            // $('.hidden-count').removeClass('hidden-count');
            var totalPrice = Shopify.formatMoney(cart.total_price, "");
            $(".cart-drawer__subtotal-number").html(totalPrice);
            // console.log(cart)
          });

          $addToCartBtn.removeClass('btn--loading');
          themeAPI.addToCartflip($addToCartBtn, lineItem);
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold out");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          if($addToCartBtn.closest('form').siblings('.error-note').length > 0){
            $addToCartBtn.closest('form').siblings('.error-note').show();
          }else{
            $addToCartBtn.after('<p class="note errors text-size-12">' + response + '</p>');
          }
        }
      });
    }
  });
};

// Initialize theme's JS on docready
$(themeAPI.init)

